module.exports = __webpack_public_path__ + "img/rain_dark.be357c6d.svg";